import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';

import { ICPQuoteParams, InitialState } from './myQuote.interface';

const initialQuoteParams: ICPQuoteParams = {
    page: 1,
    search: '',
    member: 'all',
    startDate: null,
    endDate: null,
    sortType: 'desc',
    sortField: 'updatedAt',
    limit: 25,
    status: 'All',
    classification: null,
};

const initialState: InitialState = {
    quoteParams: initialQuoteParams,
    activeTab: 'All',
    tabsData: [],
    isFetchedTabs: false,
};

export const MyQuoteDashboardSlice = createSlice({
    name: 'MyQuoteDashboard',
    initialState,
    reducers: {
        resetMyQuoteDashboardState: () => initialState,
        setQuoteParams: (state, { payload }) => {
            state.quoteParams = { ...state.quoteParams, ...payload };
        },
        setActiveTab: (state, { payload }) => {
            state.activeTab = payload;
        },
        setTabsData: (state, { payload }) => {
            state.tabsData = payload;
        },
        setIsFetched: (state, { payload }) => {
            state.isFetchedTabs = payload;
        },
    },
});

export default MyQuoteDashboardSlice.reducer;

export const { resetMyQuoteDashboardState, setQuoteParams, setActiveTab, setTabsData, setIsFetched } = MyQuoteDashboardSlice.actions;

export const quoteParamsData = (state: RootState) => state.MyQuoteDashboard.quoteParams || initialQuoteParams;

export const activeTabData = (state: RootState) => state.MyQuoteDashboard.activeTab || 'All';

export const tabsDataData = (state: RootState) => state.MyQuoteDashboard.tabsData || [];

export const isFetchedTabsData = (state: RootState) => state.MyQuoteDashboard.isFetchedTabs;
